<template>
  <div class="branding-banner">
    <span class="font-bold">invoi.cf</span>
  </div>
</template>
